/*
 * @Author: wentao
 * @Date: 2021-07-12 09:10:29
 * @LastEditTime: 2021-08-18 16:56:38
 * @LastEditors: wentao
 * @Description: 
 */
import moment from 'moment'

function setDateMaterialFormat(date) {
	date.adMaterialDetail.forEach((item) => {
		let _playDates = []
		item.playDates &&
			item.playDates.forEach((i) => {
				i = i.split('|')
				_playDates.push(...getDiffList(i[0], i[1], 'days'))
			})
		item.playDates = _playDates
	})
	return date
}

function getDiffList(beginTime, endTime, type) {
	//对年月日处理成年月moment(currentDate).format('YYYY-MM')
	var dateArray = [] // dateArray 起止日期中间的所有日期列表
	var currentDate = moment(beginTime) //起止日期
	var stopDate = moment(endTime) //截止日期
	//开始日期小于等于结束日期,并循环
	while (currentDate <= stopDate) {
		if (type === 'days')
			dateArray.push(moment(currentDate).format('YYYY-MM-DD')) //两个日期间的所有日期
		if (type === 'months')
			dateArray.push(moment(currentDate).format('YYYY-MM')) //两个月份间的所有月份
		if (type === 'years') dateArray.push(moment(currentDate).format('YYYY')) //两个年份间的所有年份
		currentDate = moment(currentDate).add(1, type) //根据类型+1
	}
	return dateArray
}

function validateTextLength(value) {
	// 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
	let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
	let mat = value.match(cnReg)
	let length = 0
	if (mat) {
		length = mat.length + (value.length - mat.length) * 0.5
		return length
	} else {
		return value.length * 0.5
	}
}
// 将单个时间处理成时间段['2021-06-09','2021-06-10','2021-06-12']
// ["2021-06-09|2021-06-10","2021-06-12|2021-06-12"]

function getplayDates(dateList) {
	if (!dateList) return []
	dateList = JSON.parse(JSON.stringify(dateList.sort()))
	let _playDates = []
	//得到[[],[],[]]二维数组
	for (let i = 0; i < dateList.length; i++) {
		const arr = [dateList[i], dateList[i]]
		for (let j = i + 1; j < dateList.length; j++) {
			//如果相差一天
			if (
				Date.parse(dateList[j]) - Date.parse(arr[1]) ==
				24 * 3600 * 1000
			) {
				arr[1] = dateList[j]
				dateList.splice(j, 1)
				j--
			}
		}
		_playDates.push(arr)
	}
	//将二维数组转换为一维数组
	let playDates = []
	for (let i = 0; i < _playDates.length; i++) {
		const element = _playDates[i]
		playDates.push(element.join('|'))
	}
	return playDates
}
export { setDateMaterialFormat, getDiffList, validateTextLength, getplayDates }
